// v0.5.0i+4 — Extracted from UploadPanel.jsx during the LOC-cap
// refactor pass. Static adapter metadata + adapter-class sets used
// by the upload form. No runtime logic lives here — change-safe
// across releases.
//
// Digital-Services scope: all marketplace adapters (Amazon / eBay /
// Shopify / WooCommerce) were pruned. The only ingestion source is
// the operator-facing client template.
import { ClipboardText } from "@phosphor-icons/react";

export const ADAPTER_CARDS = {
  client_template: { icon: ClipboardText, name: "Client template", hint: "Manually-prepared XLSX / CSV (template below)" },
};

export const XLSX_ADAPTERS = new Set(["client_template"]);

// Adapters whose raw export has NO Currency column and need an
// operator-declared currency at upload. The client template carries
// a per-row Currency column, so this set is now empty.
export const SINGLE_CURRENCY_ADAPTERS = new Set([]);

export const CURRENCY_OPTIONS = ["GBP", "EUR", "USD", "AUD", "CAD"];
